/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelListResult } from '../../models/team-model-list-result';

export interface ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params {
  ConferenceIds?: Array<number>;
}

export function apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse.PATH, 'get');
  if (params) {
    rb.query('ConferenceIds', params.ConferenceIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamModelListResult>;
    })
  );
}

apiTeamTeamsGet$JsonOdataMetadataMinimalOdataStreamingFalse.PATH = '/api/team/teams';
